var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");

var SymbolTerminalInteractionView = require("./symbolTerminalInteractionView.js");
var SymbolTerminalInteractionModel = require("./symbolTerminalInteractionModel.js");

var SymbolTerminalViewerController = function(archLayers, dependencies, configuration) {
    editor_2d.AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SymbolTerminalViewerController, editor_2d.AbstractViewerController);
SymbolTerminalViewerController.inject = lib_core.clone(editor_2d.AbstractViewerController.inject);

module.exports = SymbolTerminalViewerController;

SymbolTerminalViewerController.prototype.beforeLoad = function () {
    editor_2d.AbstractViewerController.prototype.beforeLoad.call(this);
};

SymbolTerminalViewerController.prototype.getDataType = function () {
    return cio_datamodel.SymbolTerminalData;
};

SymbolTerminalViewerController.prototype.getInteractionViewType = function () {
    return SymbolTerminalInteractionView;
};

SymbolTerminalViewerController.prototype.getInteractionModelType = function () {
    return SymbolTerminalInteractionModel;
};
